import React from "react";

const Prastavna = () => {
  const mockData = {
    title:
      "अकोला–खंडवा गेज परिवर्तन–प्रस्तावित ब्रॉडगेजसाठी भूमिसंपादन प्रस्ताव",
    heading: "प्रस्तावना",
    content: [
      "इ. स. १९९५ पासून अस्तित्वात असलेल्या अकोला–खंडवा (१९७.३२० कि.मी.) मीटर गेज रेल्वे मार्गाचे ब्रॉडगेजमध्ये परिवर्तन करण्याचे उद्दिष्ट डिसेंबर २०२५ पर्यंत निश्चित करण्यात आले आहे.",
      "अकोला–खंडवा विभागाचे गेज परिवर्तनाचे काम झाल्यानंतर हा मार्ग प्रवासी व मालवाहतुकीसाठी सुविधाजनक ठरणार आहे.",
      "सध्या अस्तित्वात असलेला ब्रॉडगेज रेल्वे मार्ग हा खंडवा–भुसावळ–अकोला हा जास्त लांबीचा मार्ग आहे. परंतु अकोला–खंडवा गेज परिवर्तन झाल्यानंतर अंतर कमी होऊन वेळ, इंधन व वाहतूक खर्चात बचत होणार आहे.",
      "तसेच या मार्गामुळे परिसरातील औद्योगिक व आर्थिक विकासास चालना मिळणार आहे.",
      "प्रस्तावित अकोला–खंडवा गेज परिवर्तन अंतर्गत आवश्यक असलेली जमीन संपादन करणे अत्यावश्यक असून त्यासाठी सदर प्रस्ताव सादर करण्यात येत आहे."
    ],
    footer: "उपकार्यकारी अभियंता, (बांधकाम विभाग), दक्षिण मध्य रेल्वे, अकोला"
  };

  return (
    <div className="max-w-4xl mx-auto p-8 bg-white text-black">
      {/* Title */}
      <h2 className="text-center font-semibold mb-6">
        {mockData.title}
      </h2>

      {/* Heading */}
      <h3 className="text-center font-bold underline mb-6">
        {mockData.heading}
      </h3>

      {/* Content */}
      <div className="space-y-4 text-justify leading-7">
        {mockData.content.map((para, index) => (
          <p key={index}>{para}</p>
        ))}
      </div>

      {/* Footer */}
      <div className="mt-12 text-right font-medium">
        <p>{mockData.footer}</p>
      </div>
    </div>
  );
};

export default Prastavna;
